import React, { useState } from "react";
import CreateBlog from "./CreateBlog";
import BlogTable from "./BlogTable";

const TopNavbar = () => {
  const [activeContent, setActiveContent] = useState("Create Blog");

  const menuItems = [
    {
      name: "Create Blog",
      key: "Create Blog",
      component: <CreateBlog />,
    },
    {
      name: "Blog Management",
      key: "Blog Management",
      component: <BlogTable />,
    },
  ];

  return (
    <>
      <div>
        <nav className="bg-white text-black p-3 shadow-md">
          <div className="flex justify-between items-center">
            <ul className="flex space-x-3">
              {menuItems.map((item) => (
                <li key={item.key}>
                  <button
                    onClick={() => setActiveContent(item.key)}
                    className={`px-4 py-2 border-b-2 ${
                      activeContent === item.key
                        ? "border-blue-500 text-blue-500"
                        : "border-transparent"
                    }`}
                  >
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </nav>
        <div className="p-5 flex-grow py-10 h-auto w-full">
          {menuItems.map(
            (item) =>
              activeContent === item.key && (
                <div key={item.key} className="w-full">
                  {item.component}
                </div>
              )
          )}
        </div>
      </div>
    </>
  );
};

export default TopNavbar;
